export default "__VITE_ASSET__nwDmHCN0__"